"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Monitor_1;
Object.defineProperty(exports, "__esModule", { value: true });
"use strict";
const z_index_1 = require("./internal/z.index");
const Config_1 = require("./Config");
const Config_decorators_1 = require("./Config.decorators");
const Transaction_1 = require("./Transaction");
let Monitor = Monitor_1 = class Monitor {
    constructor(prolonged = false, separate = Config_1.SeparateFrom.All) {
        this._idle = true;
        this._counter = 0;
        this._workers = new Set();
        this.prolonged = prolonged;
        this.separate = separate;
    }
    get isIdle() { return this._idle; }
    get counter() { return this._counter; }
    get workers() { return this._workers; }
    enter(worker) {
        if (this._counter === 0)
            this._idle = false;
        this._counter++;
        this._workers.add(worker);
    }
    leave(worker) {
        this._workers.delete(worker);
        this._counter--;
        if (this._counter === 0)
            this._idle = true;
    }
    static create(hint, prolonged = false, separate = Config_1.SeparateFrom.All) {
        return Transaction_1.Transaction.run(() => z_index_1.Handle.setHint(new Monitor_1(prolonged, separate), hint));
    }
};
Monitor = Monitor_1 = __decorate([
    Config_decorators_1.stateful,
    __metadata("design:paramtypes", [Boolean, Number])
], Monitor);
exports.Monitor = Monitor;
